import { render, staticRenderFns } from "./StudentsExport.vue?vue&type=template&id=1da679d6&"
import script from "./StudentsExport.vue?vue&type=script&lang=js&"
export * from "./StudentsExport.vue?vue&type=script&lang=js&"
import style0 from "./StudentsExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports